import Layout from '../Layout';
import MobileLayout from '../MobileLayout';
import Footer from 'comps/Footer';
import Header from 'comps/Header';

// 获取临时的布局组件函数，用于项目治理中的过渡，整改过后会删除
export default function getTemporaryLayout(pageComponent, layoutProps, isMobile) {
  return !isMobile ? (
    <Layout
      header={<Header showArPeaCascader={false} showNav={false} />}
      footer={<Footer />}
      title={layoutProps.title}
      keywords=""
      description=""
      bgColor="#ffffff"
    >
      {pageComponent}
    </Layout>
  ) : (
    <MobileLayout title={layoutProps.title} keywords="" description="">
      {pageComponent}
    </MobileLayout>
  );
}
